import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

import { PremioLojaItem } from '../types'
import { Paginacao } from './Paginacao'
import { PrêmioRender } from './PrêmioRender'
import { PremiosSkeleton } from './PremiosSkeleton'

interface TabsPrêmiosProps {
  activeTab: string
  setActiveTab: (value: string) => void
  premios: PremioLojaItem[]
  isLoadingByRanking: boolean
  currentPage: number
  totalPages: number
  setCurrentPage: (page: number) => void
  setSearchParams: (
    updater: (params: URLSearchParams) => URLSearchParams,
  ) => void
  buscaWatch?: string
}

export const TabsPrêmios = ({
  activeTab,
  setActiveTab,
  premios,
  isLoadingByRanking,
  currentPage,
  totalPages,
  setCurrentPage,
  setSearchParams,
  buscaWatch,
}: TabsPrêmiosProps) => {
  return (
    <Tabs
      value={activeTab}
      onValueChange={setActiveTab}
      defaultValue='available'
      className='w-full'
    >
      <TabsList className='mb-6 grid w-full grid-cols-2 gap-3 bg-transparent'>
        <TabsTrigger
          className='borde h-10 rounded-xl border border-[#262626] bg-esforce-black-300/70 font-dm-sans text-sm font-semibold text-esforce-white-100 data-[state=active]:border-esforce-green-200 data-[state=active]:bg-esforce-green-200/20 data-[state=active]:text-esforce-green-200'
          value='available'
          onClick={() => {
            setSearchParams((params) => {
              params.set('disponivel', 'true')
              return params
            })
            setCurrentPage(1)
          }}
        >
          Disponíveis
        </TabsTrigger>

        <TabsTrigger
          className='borde h-10 rounded-xl border border-[#262626] bg-esforce-black-300/70 font-dm-sans text-sm font-semibold text-esforce-white-100 data-[state=active]:border-esforce-green-200 data-[state=active]:bg-esforce-green-200/20 data-[state=active]:text-esforce-green-200'
          value='all-gifts'
          onClick={() => {
            setSearchParams((params) => {
              params.delete('disponivel')
              return params
            })
            setCurrentPage(1)
          }}
        >
          Todos os prêmios
        </TabsTrigger>
      </TabsList>

      <TabsContent
        value='available'
        className='hidden max-h-[calc(100vh-405px)] flex-col items-center gap-3 overflow-y-auto data-[state=active]:flex'
      >
        {isLoadingByRanking ? (
          <>
            {Array.from({ length: 5 }).map((_, index) => (
              <PremiosSkeleton key={index} />
            ))}
          </>
        ) : premios && premios.length > 0 ? (
          premios.filter((premio) => premio.estoque > 0).length > 0 ? (
            <>
              {premios
                .filter((premio) => premio.estoque > 0)
                .map((premio) => (
                  <PrêmioRender key={premio.id} premio={premio} />
                ))}

              <Paginacao
                currentPage={currentPage}
                totalPages={totalPages}
                setCurrentPage={setCurrentPage}
              />
            </>
          ) : (
            <p className='flex h-full items-center justify-center text-center font-dm-sans text-xl font-medium text-white'>
              Nenhum produto disponível encontrado
            </p>
          )
        ) : (
          <p className='flex h-full items-center justify-center text-center font-dm-sans text-xl font-medium text-white'>
            Nenhum produto disponível encontrado
          </p>
        )}
      </TabsContent>

      <TabsContent
        value='all-gifts'
        className='hidden max-h-[calc(100vh-405px)] flex-col items-center gap-3 overflow-y-auto data-[state=active]:flex'
      >
        {isLoadingByRanking ? (
          <PremiosSkeleton />
        ) : premios && premios.length > 0 ? (
          <>
            {premios.map((premio) => (
              <PrêmioRender key={premio.id} premio={premio} />
            ))}

            <Paginacao
              currentPage={currentPage}
              totalPages={totalPages}
              setCurrentPage={setCurrentPage}
            />
          </>
        ) : (
          <p className='flex h-full items-center justify-center text-center font-dm-sans text-xl font-medium text-white'>
            Nenhum produto encontrado como: {buscaWatch}
          </p>
        )}
      </TabsContent>
    </Tabs>
  )
}
